import type { QueryClient } from '@tanstack/react-query';
import { binaryTreeAPI } from '../api/binary-tree';

export const GLOBAL_TABLE_PAGE_SIZE = 80;
/** Visible BFS layers relative to the current root (1.1 → 2.x → 3.x). */
export const GLOBAL_TABLE_VISIBLE_DEPTH = 3;
export const GLOBAL_TABLE_QUERY_KEY = ['binary-tree', 'global-table'] as const;
export const GLOBAL_TABLE_STALE_MS = 30_000;

export function globalTableQueryKey(
  rootFilter = '',
  rootUserId: number | null = null,
  page = 1,
  maxDepth: number | null = GLOBAL_TABLE_VISIBLE_DEPTH,
): readonly unknown[] {
  return [...GLOBAL_TABLE_QUERY_KEY, rootFilter, rootUserId, page, maxDepth];
}

/** Warm global players table while user navigates the app. */
export function prefetchGlobalTable(qc: QueryClient, rootFilter = '', rootUserId: number | null = null): void {
  void qc.prefetchQuery({
    queryKey: globalTableQueryKey(rootFilter, rootUserId, 1),
    queryFn: () =>
      binaryTreeAPI.getGlobalTable({
        ...(rootUserId != null && rootUserId > 0
          ? { root_user_id: rootUserId }
          : rootFilter
            ? { root_player_number: rootFilter }
            : {}),
        page: 1,
        limit: GLOBAL_TABLE_PAGE_SIZE,
        max_depth: GLOBAL_TABLE_VISIBLE_DEPTH,
      }),
    staleTime: GLOBAL_TABLE_STALE_MS,
  });
}

/** Prefetch drill-down subtree before navigation updates URL state. */
export function prefetchGlobalTableDrill(
  qc: QueryClient,
  rootFilter: string,
  rootUserId: number,
): void {
  void qc.prefetchQuery({
    queryKey: globalTableQueryKey(rootFilter, rootUserId, 1),
    queryFn: () =>
      binaryTreeAPI.getGlobalTable({
        root_user_id: rootUserId,
        page: 1,
        limit: GLOBAL_TABLE_PAGE_SIZE,
        max_depth: GLOBAL_TABLE_VISIBLE_DEPTH,
      }),
    staleTime: GLOBAL_TABLE_STALE_MS,
  });
}
